import { pubSub } from "../../infrastructure/pubSub";
import { IUpdateEmailParams, UserProfileAPI } from "../../services/hcnApi";
import { TOASTS } from "../../types/toast";

export const updateEmailUseCase = async ({
  code,
}: IUpdateEmailParams): Promise<{
  success: boolean;
}> => {
  try {
    await UserProfileAPI.updateEmail({ code });
    // since we have no response on this API call success, we are setting up a {success: true/false} response here in the usecase
    return { success: true };
  } catch (e) {
    // TODO error handling
    console.log(e);
    pubSub.emit(TOASTS.ERROR, { message: "Email update failed" });
    return { success: false };
  }
};
